module.exports = __webpack_public_path__ + "img/weibo.2c964504.png";